import { render, staticRenderFns } from "./DashboardAdviser.vue?vue&type=template&id=1152114a&scoped=true&"
import script from "./DashboardAdviser.vue?vue&type=script&lang=js&"
export * from "./DashboardAdviser.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdviser.vue?vue&type=style&index=0&id=1152114a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152114a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VOverlay,VProgressCircular,VRow})
